// require("dotenv").config();
// const environment = "demo_botiaml";
const environment = "prod";
// const environment="uat_internal"
// const environment="uat_internal"
// const environment="Dev_env"
// const environment="pro_internal"
let domain,
  instance_type,
  chatbot_api_host,
  chatbot_api_root,
  vefification_api,
  signup_api;

if (environment === "uat") {
  domain = "hr_finance";
  instance_type = "backend";

  chatbot_api_root = "https://uat.adya.indianbank.in";
  chatbot_api_host = "https://uat.adya.indianbank.in/dev_chatbot_api";
  vefification_api = "https://uat.adya.indianbank.in/dev_chatbot_api/varifyUser";

} if (environment === "uat_internal") {
  domain = "hr_finance";
  instance_type = "backend";

  chatbot_api_root = "https://uat.chatbotapp.ib.in:8095";
  chatbot_api_host = "https://uat.chatbotapp.ib.in:8095/dev_chatbot_api";
  vefification_api = "https://uat.chatbotapp.ib.in:8095/dev_chatbot_api/varifyUser";

}
if (environment === "pro_internal") {
  domain = "hr_finance";
  instance_type = "backend";

  chatbot_api_root = "https://chatbot.ib.in:8095";
  chatbot_api_host = "https://chatbot.ib.in:8095/dev_chatbot_api";
  vefification_api = "https://chatbot.ib.in:8095/dev_chatbot_api/varifyUser";

}
else if (environment === "Dev_env") {
  console.log("environment: ", environment);
  // nlp_gateway_host = "hermesbetahr.workflo.ai";
  // nlp_gateway_port = 20000;
  // nlp_gateway_url =
  //   "https://hermesbetahr.workflo.ai:19002/conversation/request/v0";

  domain = "hr_finance";
  instance_type = "backend";

  // Local Host with Context Path: dev_chatbot_api
  chatbot_api_root = "https://192.168.1.131:8094";
  chatbot_api_host = "https://192.168.1.131:8094/dev_chatbot_api";
  vefification_api = "https://192.168.1.131:8094/dev_chatbot_api/varifyUser";

  // export const zoom_app_host = 'localhost'
  // zoom_app_host = "hermesbetahr.workflo.ai";
  // zoom_app_port = 8093;
}
else if (environment === "local") {
  console.log("environment: ", environment);
  // nlp_gateway_host = "hermesbetahr.workflo.ai";
  // nlp_gateway_port = 20000;
  // nlp_gateway_url =
  //   "https://hermesbetahr.workflo.ai:19002/conversation/request/v0";

  domain = "hr_finance";
  instance_type = "backend";

  // Local Host with Context Path: dev_chatbot_api
  chatbot_api_root = "https://localhost:8094";
  chatbot_api_host = "https://localhost:8094/dev_chatbot_api";
  vefification_api = "https://localhost:8094/dev_chatbot_api/varifyUser";

  // export const zoom_app_host = 'localhost'
  // zoom_app_host = "hermesbetahr.workflo.ai";
  // zoom_app_port = 8093;
} else if (environment === "localhttp") {
  console.log("environment: ", environment);
  // nlp_gateway_host = "hermesbetahr.workflo.ai";
  // nlp_gateway_port = 20000;
  // nlp_gateway_url =
  //   "https://hermesbetahr.workflo.ai:19002/conversation/request/v0";

  domain = "hr_finance";
  instance_type = "backend";

  // Local Host with Context Path: dev_chatbot_api
  chatbot_api_root = "https://localhost:8094";
  chatbot_api_host = "https://localhost:8094/dev_chatbot_api";
  vefification_api = "https://localhost:8094/dev_chatbot_api/varifyUser";

  // export const zoom_app_host = 'localhost'
  // zoom_app_host = "hermesbetahr.workflo.ai";
  // zoom_app_port = 8093;
} else if (environment === "ipoffline") {
  console.log("environment: ", environment);
  // nlp_gateway_host = "hermesbetahr.workflo.ai";
  // nlp_gateway_port = 20000;
  // nlp_gateway_url =
  //   "https://hermesbetahr.workflo.ai:19002/conversation/request/v0";

  domain = "hr_finance";
  instance_type = "backend";

  // Local Host with Context Path: dev_chatbot_api
  chatbot_api_root = "https://10.10.20.95:8102";
  chatbot_api_host = "https://10.10.20.95:8102/dev_rbihchatbot_api";
  vefification_api = "https://10.10.20.95:8102/dev_rbihchatbot_api/varifyUser";

  // export const zoom_app_host = 'localhost'
  // zoom_app_host = "hermesbetahr.workflo.ai";
  // zoom_app_port = 8093;
} else if (environment === "app_prod") {
  domain = "hr_finance";
  instance_type = "backend";

  chatbot_api_root = "https://10.203.86.11:8094";
  chatbot_api_host = "https://10.203.86.11:8094/dev_chatbot_api";
  vefification_api = "https://10.203.86.11:8094/dev_chatbot_api/varifyUser";
} else if (environment === "prod") {
  domain = "hr_finance";
  instance_type = "backend";
  chatbot_api_root = "https://chatbot.indianbank.in";
  chatbot_api_host = "https://chatbot.indianbank.in/dev_chatbot_api";
  vefification_api = "https://chatbot.indianbank.in/dev_chatbot_api/varifyUser";
} else if (environment === "webIpProd") {
  domain = "hr_finance";
  instance_type = "backend";

  chatbot_api_root = "https://10.203.71.144";
  chatbot_api_host = "https://10.203.71.144/dev_chatbot_api";
  vefification_api = "https://10.203.71.144/dev_chatbot_api/varifyUser";
} else if (environment === "demo_botiaml") {
  domain = "hr_finance";
  instance_type = "backend";

  //demo.botaiml.com
  chatbot_api_root = "https://demo.botaiml.com";
  chatbot_api_host = "https://demo.botaiml.com/dev_chatbot_api";
  vefification_api = "https://demo.botaiml.com/dev_chatbot_api/varifyUser";
  // signup_api = "https://demo.botaiml.com/dev_chatbot_api/createUser";
  // videoflo_url = "https://demo.botaiml.com/dev_chatbot_api/join-session";
} else if (environment === "rbih") {
  domain = "hr_finance";
  instance_type = "backend";

  //demo.botaiml.com
  chatbot_api_root = "https://demo.botaiml.com";
  chatbot_api_host = "https://demo.botaiml.com/dev_rbihchatbot_api";
  vefification_api = "https://demo.botaiml.com/dev_rbihchatbot_api/varifyUser";
  // signup_api = "https://demo.botaiml.com/dev_chatbot_api/createUser";
  // videoflo_url = "https://demo.botaiml.com/dev_chatbot_api/join-session";
} else if (environment === "hermes") {
  domain = "hr_finance";
  instance_type = "backend";

  // HERMES
  // chatbot_api_host = "https://hermesbetahr.workflo.ai:8094";
  // vefification_api = "https://hermesbetahr.workflo.ai:8094/varifyUser";
  // signup_api = "https://hermesbetahr.workflo.ai:8094/createUser";
  // videoflo_url = "https://hermesbetahr.workflo.ai:8094/join-session";
}

export {
  domain,
  instance_type,
  chatbot_api_host,
  chatbot_api_root,
  vefification_api,
  signup_api,
};
